import { useEffect, useState } from 'react'

export default function useAcknowledgeOptions(optionName, optionEndpointName, transform, other) {
    const [options, setOptions] = useState(other ? [other] : [])

    useEffect(() => {
        const abortController = new AbortController()

        fetch(`/services/plugin-channel-alarms/settings/acknowledge/${optionEndpointName}`, {
            signal: abortController.signal
        })
            .then(r => {
                if (r.ok) {
                    return r.json()
                }

                console.error(`Could not get current ${optionName}s`, r.status, r.statusText)

                return Promise.resolve([])
            })
            .then(r => {
                // IMPORTANT: remember to pass the transform function wrapped in useCallback
                const persistedOptions = transform(r)

                // IMPORTANT: remember to pass 'other' wrapped in useMemo if not falsy
                if (other) {
                    if (
                        Array.isArray(persistedOptions) &&
                        !persistedOptions.find(({ resolution }) => resolution.toLowerCase() === 'other')
                    ) {
                        persistedOptions.push(other)
                    } else if (!persistedOptions.other) {
                        persistedOptions.other = other
                    }
                }

                setOptions(persistedOptions)
            })
            .catch(err => {
                if (err.name !== 'AbortError') {
                    console.error('Error getting acknowledge options:', err)
                }
            })

        return () => {
            abortController.abort()
        }
    }, [optionEndpointName, optionName, other, transform])

    return options
}
